export function updatePharmacyListTitle(title) {
    return {
        type: 'SET_PHARMACY_TITLE',
        payload: title
    }
}


// WEBPACK FOOTER //
// ./src/actions/metaActions.js